@if (isValid) {
  <img
    src="{{ flagSvgPath }}/{{ location.code }}.svg"
    [alt]="'Flag of ' + location.name"
    [ngClass]="{ regular: size === 'regular', large: size === 'large' }"
    [attr.aria-hidden]="ariaHidden"
  />
}
